import {
  useLiveAnnouncer,
  type UseLiveAnnouncer,
} from '@/shared/hooks/useLiveAnnouncer/useLiveAnnouncer';

export type UseScalarAnnouncer = UseLiveAnnouncer;

/** The `uiKit` sentence a scalar field owes when it refuses an edit. */
const READ_ONLY_REFUSAL_KEY = 'scalar.readOnlyRefused';

/**
 * What the scalar family says out loud.
 *
 * The family's own vocabulary over the shared `useLiveAnnouncer`: one sentence
 * for a refusal, wherever it comes from, so a duration and a percent cannot
 * word the same event two ways. Everything specific to one control — the unit
 * it switched to, the rounding it declined to do — goes through `say`.
 */
export function useScalarAnnouncer(): UseScalarAnnouncer {
  return useLiveAnnouncer(READ_ONLY_REFUSAL_KEY);
}
